import { Skeleton } from "antd";
import { StyledAppsContainerSidebarCard } from "./index.styled";
import { useSidebar } from "@lib/context/SidebarContext";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";

export type AppsContainerSidebarCardProps = {
  loading?: boolean;
  children: React.ReactNode;
  minWidth?: string;
  maxWidth?: string;
  cardProps?: AppCardProps;
};

export default function AppsContainerSidebarCard(
  props: AppsContainerSidebarCardProps,
) {
  const {
    children,
    loading,
    minWidth,
    maxWidth,
    cardProps = {
      borderFull: true,
      coloredHeader: true,
    },
  } = props;
  const { collapsed } = useSidebar();

  if (loading) return <Skeleton active />;

  return (
    <StyledAppsContainerSidebarCard
      collapsed={collapsed}
      minWidth={minWidth}
      maxWidth={maxWidth}
      {...cardProps}
    >
      {children}
    </StyledAppsContainerSidebarCard>
  );
}
